import React, { useMemo, useState } from "react";
import "./VideoPlayer.scss";
import PlayIcon from "../PlayIcon/PlayIcon";
import ReactPlayer from "react-player";

const VideoPlayer = ({
  themeColor,
  url,
  videoSize,
  landing = false,
  controls = true,
  className,
  onPlay,
}) => {
  const [videoPlaying, setVideoPlaying] = useState(false);

  const containerClass = useMemo(() => {
    if (landing === true) {
      return "videoContainerLanding";
    } else {
      return "videoContainer";
    }
  }, [landing]);
  const playVideo = () => {
    setVideoPlaying(true);
  };

  return (
    <div className={containerClass}>
      {!videoPlaying && (
        <div className={"playContainer"} onClick={playVideo}>
          <PlayIcon themeColor={themeColor} />
        </div>
      )}

      <ReactPlayer
        playing={videoPlaying}
        url={url}
        width={videoSize.width}
        controls={controls}
        height={videoSize.height}
        playIcon={<PlayIcon themeColor={themeColor} />}
        className={className}
        onPlay={onPlay}
      />
    </div>
  );
};

export default VideoPlayer;
